module.exports = __webpack_public_path__ + "static/media/5.cb944063.jpeg";